import React, {useState} from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {FaRegEyeSlash} from 'react-icons/fa';
import {BsFillCheckCircleFill} from 'react-icons/bs';
import { useNavigate } from 'react-router';
import styles from './styles.module.css';
import axios from 'axios';


const SignupForm = () => {

  const request = (values) => {
    axios.post('https://aphrodite-01.herokuapp.com/auth/signup', values)
    .then((response) =>{
      console.log(response);
    })
    .catch((error)=>{
      console.log(error);
    })
  }
  const [isModalDisplay, setModalDisplay] = useState(true);
  
  let navigate = useNavigate();
  function handleClick() {
    navigate('/login')
  }
  let navigate_verify = useNavigate();
  function handleClick2() {
    // navigate_verify('/verify')
    navigate_verify('/login')
  }

    // Initialize a boolean state as false (i.e. shouldn't show password)
    const [passwordShown, setPasswordShown] = useState(false);

    const togglePassword = () => {
        // When the handler is invoked
        // inverse the boolean state of passwordShown
        setPasswordShown(!passwordShown);
      };
    
    
  // Pass the useFormik() hook initial form values and a submit function that will
  // be called when the form is submitted
  const formik = useFormik({
    initialValues: {
      fullName: '',
      userName: '',
      email: '',
      password: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
        fullName: Yup.string()
          .required('Required'),
        userName: Yup.string()
          .required('Required'),
        email: Yup.string().email('Invalid email address').required('Required'),
        password: Yup.string()
        .required('Please Enter your password, enter a strong password for your own good!'),
        
        confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Enter password confirmation'),
      }),
        onSubmit: (values) => {
          setModalDisplay(!isModalDisplay);
          const data = {
            fullName: values.fullName,
            userName: values.userName,
            email: values.email,
            password: values.password
          }
          // console.log(data);
          request(data);
    },
  });
  return (
      <div className = {styles.signupForm}>
          <div className = {styles.flex_items}>
           <h3 className = {styles.create_account}>
        Create account
           </h3>
           <h4 className = {styles.sign_in} onClick={handleClick}>
        Sign in
           </h4>
      </div>
      <form className = {styles.forms} onSubmit={formik.handleSubmit}>
      <label className = {styles.label} htmlFor="fullName">Full Name</label> <br />
      <input
        className = {styles.input}
        id="fullName"
        name="fullName"
        type="text"
        onChange={formik.handleChange}
        value={formik.values.fullName}
      /> <br />
      {formik.touched.fullName && formik.errors.fullName ? (
         <div>{formik.errors.fullName}</div>
       ) : null}



      <label className = {styles.label} htmlFor="userName">Preferred User Name</label> <br />
      <input
        className = {styles.input}
        id="userName"
        name="userName"
        type="text"
        onChange={formik.handleChange}
        value={formik.values.userName}
      /> <br />
      {formik.touched.userName && formik.errors.userName ? (
         <div>{formik.errors.userName}</div>
       ) : null}




      <label className = {styles.label} htmlFor="email">Email Address</label> <br />
      <input
        className ={styles.input}
        id="email"
        name="email"
        type="email"
        onChange={formik.handleChange}
        value={formik.values.email}
      /> <br />
      {formik.touched.email && formik.errors.email ? (
         <div>{formik.errors.email}</div>
       ) : null}
       
      <label className = {styles.label} htmlFor="password">Password <span className = "char">(Enter atleast 8 characters)</span>
      </label> <br />

       <input
        className = {styles.input}
        id="password"
        minLength = "8"
        name="password"
        type={passwordShown ? "text" : "password"}
        onChange={formik.handleChange}
        value={formik.values.password}
      />
          <FaRegEyeSlash onClick={togglePassword}  size={24}/>
       <br />
      {formik.touched.password && formik.errors.password ? (
         <div>{formik.errors.password}</div>
       ) : null}

      <label className = {styles.label} htmlFor="confirmPassword">Confirm Password</label>
      <input
        className = {styles.input}
        id="confirmPassword"
        name="confirmPassword"
        type={passwordShown ? "text" : "password"}
        onChange={formik.handleChange}
        value={formik.values.confirmPassword}
      />
      
      {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
         <div>{formik.errors.confirmPassword}</div>
       ) : null}

      <button type="submit"
      className ={styles.submit}>Create new account</button>
      </form>
      <p className ={styles.par}>
      By signing up, I agree to the QNET 
      <span className = {styles.span}> Terms of use</span> and <span className = {styles.span}>Privacy Policy</span>
       </p>
       <div className = { isModalDisplay ? styles.modal : styles.modal_active}>
          {/* modal content */}
          <div className = {styles.modal_content}>
          {/* <span className = {styles.close} onClick = {formik.handleSubmit}> &times;</span> */}
            <p className = {styles.confirm}>
              <BsFillCheckCircleFill size={44} color="green"/>
              </p>
            <p className = {styles.modal_p}> Congratulations, your account has been <br /> successfully created.</p>
            <button type="submit" 
             className ={styles.modal_submit}
             onClick={handleClick2}>
              Continue
            </button>
          </div>
       </div>
      </div>
    
  );

};
export default SignupForm;